import TxpStringFormatters from '../../schema/configSchema/TxpStringFormatters';
import TxpDateTimeCallbacks from '../../schema/configSchema/TxpDateTimeCallbacks';
import datesAreEqual from 'date-fns/is_equal';
import startOfDay from 'date-fns/start_of_day';

// This method doesn't show the time part of dateTimeToParse if it's at midnight.
// So this shouldn't be used for scenarios like Flight cards.
export default function convertDateTimeToString(
    dateTimeToParse: string,
    isAccessible: boolean,
    txpStringFormatters: TxpStringFormatters,
    txpDateTimeCallbacks?: TxpDateTimeCallbacks
): string {
    let dateTimeString: string = '';
    let isTimeInMidnight: boolean;
    let dateTimeToDisplay: string;

    if (txpDateTimeCallbacks) {
        const displayDateData = txpDateTimeCallbacks.getDisplayDateData(dateTimeToParse);
        if (displayDateData) {
            isTimeInMidnight = displayDateData.isTimeInMidnight;
            dateTimeToDisplay = displayDateData.dateTimeToDisplay;
        } else {
            // not a valid date
            return null;
        }
    } else {
        const midnight = startOfDay(dateTimeToParse);
        isTimeInMidnight = datesAreEqual(midnight, dateTimeToParse);
        dateTimeToDisplay = dateTimeToParse;
    }

    if (isTimeInMidnight) {
        if (!isAccessible) {
            dateTimeString = txpStringFormatters.formatWeekDayDate(dateTimeToDisplay);
        } else {
            dateTimeString = txpStringFormatters.formatWeekDayMonthDayYear(dateTimeToDisplay);
        }
    } else {
        if (!isAccessible) {
            dateTimeString = txpStringFormatters.formatWeekDayDateTime(dateTimeToDisplay);
        } else {
            dateTimeString = txpStringFormatters.formatMonthDayShortTime(dateTimeToDisplay);
        }
    }

    return dateTimeString;
}
